import type { LocaleObject } from 'yup'
import { useI18n } from 'vue-i18n'
import { setLocale } from 'yup'

export function setLocaleYup() {
  const { t } = useI18n()

  const localeObj: LocaleObject = {
    mixed: {
      required: t('validation.mixed.required'),
    },
    string: {
      length: ({ length }) => t('validation.string.length', { n: length }),
    },
  }

  setLocale(localeObj)
}
